import React, { Component } from 'react'
import { ReactComponent as LogoIcon } from "../../svg/logo.svg";

export default class CallToAction extends Component {

  constructor(props){
    super(props)
    
  }

  getAuthContent(){
    const { openLogin, openRegister } = this.props
    return (
      <>
        <div className='cta__content__logo'>
          <LogoIcon />
        </div>
        <div className='cta__content__text'>
          <span className='bold'>
            Welcome to Mediamodifier!
          </span>
          <span className='gray'>
            You are in preview mode. Create an accout or log in to collaborate on this design!
          </span>
        </div>
        <div className='cta__content__buttons'>
          {
            openLogin ? (
              <button 
                className='btn btn-bordered'
                onClick={openLogin}
              >
                Log in
              </button>
            )
            :
            undefined
          }
          {
            openRegister ? (
              <button 
                className='btn btn-danger'
                onClick={openRegister}
              >
                Create an account
              </button>
            )
            :
            undefined
          }
        </div>
      </>
    )
  }
  
  render(){
    const { isView, className, customStyle } = this.props
    const cn = `cta ${className ? className : ''}`
    return (
      <div
        className={cn}
        style={customStyle || {}}
      >
        <div className='cta__content'>
          {
            isView ? this.getAuthContent() : undefined
          }
        </div>
      </div>
    )
  }

}